const ID = 'follow';

export default ID;
